import { useLanguage } from "../../../contexts/LanguageContext";
import { DASHBOARD_RANGES } from "../useDashboardParams";
import { SegmentedControl } from "./ui";

export default function RangePicker({ value, onChange }) {
  const { t } = useLanguage();
  return (
    <SegmentedControl
      dark
      label={t("dashboard.range.label")}
      value={value}
      onChange={onChange}
      options={DASHBOARD_RANGES.map((days) => ({
        value: days,
        label: t("dashboard.range.days", { count: days }),
      }))}
    />
  );
}
